import { Construction, ArrowLeft } from "lucide-react";

// Dev-phase intercept shown to non-founders when they open Misteck Life. Founders
// bypass this and see the live workspace (see CommandStackS6 gate).
export default function MisteckLifeComingSoon({ onBack }) {
  return (
    <div
      data-testid="misteck-life-coming-soon"
      className="relative flex h-full w-full flex-col items-center justify-center gap-5 bg-[#0b1220] px-8 text-center"
    >
      {onBack && (
        <button
          onClick={onBack}
          data-testid="life-coming-soon-back"
          className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full border-2 border-white/20 bg-white/[0.06] px-3 py-2 font-mono text-[10px] font-black uppercase tracking-widest text-white active:scale-95"
        >
          <ArrowLeft size={13} /> Back
        </button>
      )}
      <div className="grid h-20 w-20 place-items-center rounded-2xl border-2 border-amber-300/40 bg-amber-300/10">
        <Construction size={38} className="text-amber-300" />
      </div>
      <h1 className="font-serif text-3xl leading-tight text-white">Misteck Life — Coming Soon 🚧</h1>
      <p className="max-w-[300px] font-mono text-[12px] leading-relaxed text-white/55">
        We're building your all-in-one life command centre — wealth, career, business and
        leisure in one place. It's almost ready. Check back shortly.
      </p>
    </div>
  );
}
